// src/pages/UnidadeOrganica/UnidadeOrganicaPage.jsx
import React from 'react';
import UnidadeOrganicaList from '../../components/UnidadeOrganica/UnidadeOrganicaList';
import { Link } from 'react-router-dom';

const UnidadeOrganicaPage = () => {
    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-bold">Gestão de Unidades Orgânicas</h1>
            <Link to="/unidades-organicas/criar" className="text-blue-500">Criar Nova Unidade Orgânica</Link>
            <UnidadeOrganicaList />
        </div>
    );
};

export default UnidadeOrganicaPage;
